var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.slotComponent,{tag:"Component",attrs:{"event":_vm.event,"highlight":_vm.highlight}})}
var staticRenderFns = []

export { render, staticRenderFns }